/**
 * Pulse UI consolidation ruling (2026-08-18): the standalone global EBA 2.0
 * Tenants control plane is retired — EBA provisioning is inherently
 * client-scoped and now lives exclusively at
 * Clients → [Client] → EBA Provisioning (ClientProvisioningTab.js, rendered
 * from ClientOverviewPage.js's "tenant" tab). This file is kept only so the
 * old `/eba2` route (Sidebar.js's removed nav item, or an existing browser
 * bookmark) resolves to a clear redirect instead of a broken/blank page —
 * there is deliberately no second functioning tenant-management surface
 * here anymore. Backend routes under `/api/eba2/*` are unchanged; this is a
 * frontend-only redirect.
 */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Buildings, ArrowRight } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

export default function Eba2ControlPlanePage() {
  const navigate = useNavigate();

  useEffect(() => {
    toast.info("EBA 2.0 tenant management has moved to Clients → [Client] → EBA Provisioning.");
  }, []);

  return (
    <div className="p-6 max-w-2xl mx-auto" data-testid="eba2-moved-notice">
      <div className="border border-[#E5E5E5] bg-white p-8 text-center">
        <Buildings size={32} className="mx-auto mb-3 text-[#A3A3A3]" />
        <h1 className="text-lg font-black tracking-tight mb-2">EBA 2.0 tenant management has moved</h1>
        <p className="text-sm text-[#525252] mb-6">
          EBA provisioning is client-scoped. Select a client, then open its <strong>EBA Provisioning</strong>{" "}
          tab to view or manage its EBA 2.0 tenant, environments, licences, and module/function entitlements.
        </p>
        <Button onClick={() => navigate("/clients", { replace: true })} data-testid="eba2-moved-go-to-clients">
          Go to Clients <ArrowRight size={14} className="ml-1.5" />
        </Button>
      </div>
    </div>
  );
}
